import { FaqSection } from 'src/components';
import { FAQ } from 'src/constants/FAQ';

export const IntegrationsFAQ = () => {
  return (
    <FaqSection
      className="mt-56"
      sections={[
        FAQ.integrations.setupMeetingNotes(),
        FAQ.integrations.slackPersonalInformation(),
        FAQ.integrations.setupStorage(),
        FAQ.integrations.updateRemarkable(),
        FAQ.integrations.supportedFileTypes(),
        FAQ.integrations.connectCloud(),
      ]}
    />
  );
};
